import React from "react"
import Image from "next/image"

const BookingIndustry  = () => {
  return (
    <div className="section-py bg-grey">
  <div className="container lg:container md:mx-auto">
    <div className="row grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 items-center">
      <div className="order-2 lg:order-1">
        <h2 className="mb-5 fw-700 fs-xl">Do you want to be a forerunner in the taxi booking industry?</h2>
        <p className="fw-400 text-secondary fs-md">
          With the introduction of e-hailing taxi applications such as Uber,
          Ola, Lyft, etc. taxi services have been one of the revolutionary
          innovations of the transportation sector. In this day and age, the
          taxi market is an extremely competitive industry. And to surpass
          this competition, all you need is a feature-rich taxi apps built by
          a leading mobile app development company like Moweb. Just like the
          leading brand Uber, a lot of businesses have initiated to invest in
          ridesharing app development by espousing a similar business strategy
          to receive a higher ROI.
        </p>
      </div>
      <div className="key-challenges-image order-1 lg:order-2">
        <Image
          src={"/img/icons/img-revenue.svg"}
          width={560}
          height={478}
          alt="revenue"
          title="revenue"
          className="img-fluid"
          loading="lazy"
          />
      </div>
    </div>
  </div>
</div>
  )
}

export default BookingIndustry
